import service from '@/utils/request';

// @Tags CheckDB
// @Summary 检查用户数据库
// @Produce  application/json
// @Success 200 {string} string "{"code":0,"data":{},"msg":"探测完成"}"
// @Router /init/checkdb [post]

export var checkDB = function checkDB() {
  return service({
    url: "/init/checkdb",
    method: 'post'
  });
};